import {default as Component} from './ConfirmationForm'
import {changeConfirmationCode} from '../../redux/actions'
import {confirmSignUp, resendConfirmationCode} from '../../redux/endpointActions'
import {connect} from 'react-redux'

const servicePath = process.env.REACT_APP_SERVICE_ENDPOINT + 'user/confirmation'
const resendPath = process.env.REACT_APP_SERVICE_ENDPOINT + 'user/confirmation/resend'

const ConfirmationForm = connect(
	(state) => ({
		username: state.userInfo.username,
		confirmationCode: state.userInfo.confirmationCode,
		disabled: state.confirmationForm.disabled,
		err: state.confirmationForm.err,
	}),
	(dispatch) => ({
		submit: (username, confirmationCode) => {
			confirmSignUp(servicePath)(username, confirmationCode)(dispatch)
		},
		confirmationCodeChanged: (confirmationCode) => {
			dispatch(changeConfirmationCode(confirmationCode))
		},
		requestConfirmationCode: (username) => {
			resendConfirmationCode(resendPath)(username)(dispatch)
		}
	})
)(Component)

ConfirmationForm.defaultProps = {
	username: null,
	confirmationCode: null,
	submit: null,
	confirmationCodeChanged: null,
	requestConfirmationCode: null,
	disabled: null
}

export default ConfirmationForm  


// WEBPACK FOOTER //
// ./src/components/ConfirmationForm/index.js